import { useState, ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'

interface HeaderProps {
  title?: string
  backTo?: string
  right?: ReactNode
}

export default function Header({ title, backTo, right }: HeaderProps) {
  const navigate = useNavigate()
  const { user, merchants, switchMerchant, logout } = useAuth()
  const [switching, setSwitching] = useState(false)

  return (
    <header className="bg-white shadow">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-6">
          <div className="flex items-center">
            {backTo ? (
              <button onClick={() => navigate(backTo)} className="text-wechat-green hover:text-wechat-dark font-medium">← 返回</button>
            ) : (
              <>
                <div className="w-10 h-10 bg-wechat-green rounded-full flex items-center justify-center">
                  <span className="text-white font-bold">微</span>
                </div>
                <h1 className="ml-3 text-2xl font-bold text-gray-900">微信转账系统</h1>
              </>
            )}
          </div>
          {title && (
            <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
          )}
          <div className="flex items-center gap-3">
            {user?.companyName && (
              <span className="text-gray-700">欢迎，{user.companyName}</span>
            )}
            {Array.isArray(merchants) && merchants.length > 1 && (
              <div className="flex items-center gap-2">
                <label className="text-sm text-gray-600">当前商户</label>
                <select
                  value={String(user?.activeMerchantId ?? '')}
                  onChange={async (e) => {
                    const mid = e.target.value
                    if (!mid) return
                    setSwitching(true)
                    try { await switchMerchant(mid) } catch (err: any) { alert(err?.message || '切换失败') } finally { setSwitching(false) }
                  }}
                  disabled={switching}
                  className="border border-gray-300 rounded-md px-2 py-1 text-sm"
                >
                  {merchants.map((m: any) => (
                    <option key={String(m.id)} value={String(m.id)}>{m.name}</option>
                  ))}
                </select>
              </div>
            )}
            {right}
            <button
              onClick={logout}
              className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-md text-sm font-medium"
            >
              退出登录
            </button>
          </div>
        </div>
      </div>
    </header>
  )
}
